import React, {Component} from 'react';
import Tilte from "../title/Tilte";
import _ from 'lodash';
import SingleCategoryItem from '../singleCategory/singleCategoryItem';

class RelatedProductsPanel extends Component {
  render() {
    let related = this.props.relatedList;
    let relatedFlowerItem = _.map(related, (singleCategory, index) => {
        return (
          <SingleCategoryItem
            key={index}
            dynamicClass="col-md-3 col-xs-12"
            info={singleCategory}
            catename={this.props.catename} />
        )
      }
    );
    let flower = relatedFlowerItem.slice(0,4);

    return(
      <div className="RelatedProductsPanel container">
        <Tilte title ="RELATED PRODUCT"/>
        <div className="RelatedProductsContainer">
          {flower}
        </div>
      </div>
    );
  }

}

export default RelatedProductsPanel;



// WEBPACK FOOTER //
// ./src/components/singleItem/relatedProductsPanel.js